/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react/no-array-index-key */
/* eslint-disable react-hooks/exhaustive-deps */
import { useState, useEffect, useRef, useContext } from "react";
import {
  Badge,
  Button,
  Combobox,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@repo/ui";
import { CircleX, RefreshCcw, SlidersHorizontal } from "lucide-react";
import { FaFileExcel } from "react-icons/fa";
import { Loader as KendoLoader } from "@progress/kendo-react-indicators";
import {
  useLookupActivityTypes,
  // useLookupAllAssignmentGroups,
  useLookupServiceAssignmentGroups,
  useLookupAllRoute,
  useLookupCashCenters,
  useLookupCustomers,
  useLookupAllMachinesServicePoints,
} from "services/lookups";
import {
  useGetEmployees,
  useGetFieldTeam,
  useGetUserByRoles,
} from "services/auth";
import { useUser } from "hooks/use-user";
import { defaultFilters, FiltersContext } from "store/filters-context";

const PERIODS = [
  { id: "All", text: "All" },
  { id: "Today", text: "Today" },
  { id: "Yesterday", text: "Yesterday" },
  { id: "This Week", text: "This Week" },
  { id: "Last Week", text: "Last Week" },
  { id: "This Month", text: "This Month" },
];

const STATUS_LIST = [
  { id: "All", text: "All" },
  { id: "Open", text: "Open" },
  { id: "Assigned", text: "Assigned" },
  { id: "Awaiting Acknowledgement", text: "Awaiting Acknowledgement" },
  { id: "Declined", text: "Declined" },
  { id: "Acknowledged", text: "Acknowledged" },
  { id: "Trip Started", text: "Trip Started" },
  { id: "Trip Skipped", text: "Trip Skipped" },
  { id: "Trip Paused", text: "Trip Paused" },
  { id: "Trip Completed", text: "Trip Completed" },
  { id: "Service Started", text: "Service Started" },
  { id: "Completed", text: "Completed" },
  { id: "On Hold", text: "On Hold" },
  { id: "Closed", text: "Closed" },
  { id: "Rejected", text: "Rejected" },
  { id: "Awaiting Customer Approval", text: "Awaiting Customer Approval" },
];
const SLA_LIST = [
  { label: "Within SLA", value: "WithinSla" },
  { label: "About to Breach", value: "AboutToBreach" },
  { label: "Breach", value: "Breach" },
  { label: "Breach Escalation", value: "BreachEscalation" },
];

function TaskFilterBarV2({
  hideAsset = false,
  hideSupervisor = false,
  hideAssignmentGroup = false,
  hideAssignee = false,
  hideStatus = false,
  exportExcel = false,
  onExcelExport = () => {},
  exportingExcel = false,
  bulkUpload = false,
  selectedRequests = [],
  assignTeam = () => {},
  isSecondaryAssigneeRequired = false,
  onRefresh = () => {},
}) {
  const { filters, setFilters } = useContext(FiltersContext);
  const [selectedCashCenter, setSelectedCashCenter] = useState(
    filters?.cashCenterId?.value || "",
  );
  const [selectedCustomer, setSelectedCustomer] = useState(
    filters?.customerId?.value || "",
  );
  const [selectedLocation, setSelectedLocation] = useState(
    filters?.assetId?.value || "",
  );
  const [selectedStatus, setSelectedStatus] = useState(
    filters?.status?.value || "All",
  );
  const [selectedDate, setSelectedDate] = useState(
    filters?.period?.value || "All",
  );
  const [selectedActivityType, setSelectedActivityType] = useState(
    filters?.activityType?.value || "",
  );
  const [selectedAssignment, setSelectedAssignment] = useState(
    filters?.assignmentGroup?.value || "",
  );
  const [selectedResponseSla, setSelectedResponseSla] = useState(
    filters?.responseSla?.value || "",
  );

  const [selectedResolutionSla, setSelectedResolutionSla] = useState(
    filters?.resolutionSla?.value || "",
  );

  const user = useUser();
  const [route, setRoute] = useState(filters?.routeNo?.value || "");
  const [assignee, setAssignee] = useState(filters?.assignedTo?.value || "");
  const [assignmentGroupList, setAssignmentGroupList] = useState("");
  const [selectedSupervisor, setSelectedSupervisor] = useState(
    user.EmployeeId || "",
  );
  const [selectedRoute, setSelectedRoute] = useState("");
  const [fieldTeam, setFieldTeam] = useState([]);
  const [selectedAssignee, setSelectedAssignee] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedSecondaryAssignee, setSelectedSecondaryAssignee] =
    useState("");
  const [filter, setFilter] = useState(filters?.searchCriteria?.value || "");
  const filterTimeout = useRef(null);

  const isSLMEngineer = user.Roles.includes("SLM Engineer Dispatcher");

  // API hooks
  const { mutate: getCashCenters, data: cashCentersList } =
    useLookupCashCenters();
  const { mutate: getCustomers, data: customersList } = useLookupCustomers();
  const { mutate: getRoutes, data: routesList } = useLookupAllRoute();
  const { mutate: getSuperVisor, data: supervisorList } = useGetUserByRoles();
  const {
    mutate: getUsers,
    data: usersList,
    reset: resetUsersList,
  } = useGetEmployees();
  const {
    mutate: getLocations,
    data: locationsList,
    reset: resetLocations,
  } = useLookupAllMachinesServicePoints();
  const {
    mutate: getFieldTeam,
    data: fieldTeamList,
    reset: resetFieldTeam,
  } = useGetFieldTeam();
  const { mutate: getActivityTypes, data: activityTypesRes } =
    useLookupActivityTypes();
  const {
    mutate: getAssignmentGroups,
    data: assignmentGroupsRes,
    reset: resetAssignmentGroups,
  } = useLookupServiceAssignmentGroups();

  useEffect(() => {
    initializeFilters();
    fetchInitialData();
  }, []);

  useEffect(() => {
    // in case filter is reset from another component e.g clicking on header resets filters
    //should replace this with event emitter package in future
    if (!filters?.cashCenterId && selectedCashCenter) {
      handleClearFilter("cashCenterId");
    }
    if (!filters?.customerId && selectedCustomer) {
      handleClearFilter("customerId");
    }
    if (!filters?.assetId && selectedLocation) {
      handleClearFilter("assetId");
    }
    if (filters?.period?.value === "All" && selectedDate !== "All") {
      handleClearFilter("period");
    }
    if (filters?.status?.value === "All" && selectedStatus !== "All") {
      handleClearFilter("status");
    }
    if (!filters?.activityType && selectedActivityType) {
      handleClearFilter("activityType");
    }
    if (!filters?.assignmentGroup && selectedAssignment) {
      handleClearFilter("assignmentGroup");
    }
    if (!filters?.searchCriteria && filter) {
      handleClearFilter("searchCriteria");
    }
    if (!filters?.routeNo && route) {
      handleClearFilter("routeNo");
    }
    if (!filters?.assignedTo && route) {
      handleClearFilter("assignedTo");
    }
    if (!filters?.responseSla && selectedResponseSla) {
      handleClearFilter("responseSla");
    }

    if (!filters?.resolutionSla && selectedResolutionSla) {
      handleClearFilter("resolutionSla");
    }
  }, [filters]);

  const initializeFilters = () => {
    const filterKeys = Object.keys(filters);
    filterKeys.forEach((key) => {
      if (!filters[key] && key in defaultFilters) {
        handleClearFilter(key);
      }
    });
  };

  const fetchInitialData = () => {
    getCashCenters();
    getCustomers();
    getActivityTypes();
    getRoutes();
    getAssignmentGroups();
    if (filters?.customerId?.value) {
      getLocations(filters?.customerId?.value);
    }
    if (isSLMEngineer) {
      getUsers("SLM Engineer");
    } else {
      getFieldTeam();
    }

    if (bulkUpload) {
      getSuperVisor(["Call Out Dispatcher"]);
    }
  };

  useEffect(() => {
    if (assignmentGroupsRes) {
      const filteredGroups = (assignmentGroupsRes?.data || [])
        .filter(
          (elm) =>
            !["Call Center", "Administrator", "Customer"].includes(elm.name),
        )
        .map((elm) => ({ label: elm.name, value: elm.name }));

      setAssignmentGroupList(filteredGroups);
      resetAssignmentGroups();
    }
  }, [assignmentGroupsRes]);

  useEffect(() => {
    if (usersList) {
      setFieldTeam(usersList?.data);
      resetUsersList();
    }
  }, [usersList]);

  useEffect(() => {
    if (fieldTeamList) {
      const formattedFieldTeam = (fieldTeamList?.data || []).map((elm) => ({
        ...elm,
        name: `${elm.name} (${elm.nationality})`,
      }));
      setFieldTeam(formattedFieldTeam);
      resetFieldTeam();
    }
  }, [fieldTeamList]);

  useEffect(() => {
    if (filter !== null) {
      filterTimeout.current = setTimeout(() => {
        handleAddFilter("searchCriteria", filter, filter, "Search");
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }, 1000);
    }
    return () => {
      if (filterTimeout.current) {
        clearTimeout(filterTimeout.current);
        filterTimeout.current = null;
      }
    };
  }, [filter]);

  const handleClearFilter = (key) => {
    const updatedFilter = { ...filters };

    if (defaultFilters[key]) {
      updatedFilter[key] = { ...defaultFilters[key] };
    } else {
      delete updatedFilter[key];
    }

    const stateSetters = {
      cashCenterId: () => setSelectedCashCenter(""),
      customerId: () => {
        setSelectedCustomer("");
        setSelectedLocation("");
        delete updatedFilter.asset;
      },
      assetId: () => setSelectedLocation(""),
      activityType: () => setSelectedActivityType(""),
      assignmentGroup: () => setSelectedAssignment(""),
      status: () => setSelectedStatus("All"),
      period: () => setSelectedDate("All"),
      searchCriteria: () => setFilter(""),
      assignedTo: () => setAssignee(""),
      routeNo: () => setRoute(""),
      responseSla: () => setSelectedResponseSla(""),
      resolutionSla: () => setSelectedResolutionSla(""),
    };

    if (stateSetters[key]) {
      stateSetters[key]();
    }

    setFilters({ ...updatedFilter });
  };

  const handleAddFilter = (key, label, value, name) => {
    if (value === "") {
      handleClearFilter(key);
      return;
    }

    setFilters({
      ...filters,
      [key]: {
        key,
        value,
        label,
        description: `${name}: ${label}`,
      },
    });
  };

  const clearAllFilters = () => {
    setFilters({ ...defaultFilters });
    setSelectedCashCenter("");
    setSelectedCustomer("");
    setSelectedDate("All");
    setSelectedLocation("");
    setFilter("");
    setSelectedActivityType("");
    setAssignee("");
    setRoute("");
    setSelectedAssignment("");
    setSelectedStatus("All");
  };

  const handleAssignTeam = () => {
    const _errors = {};

    if (!isSLMEngineer && !selectedRoute) {
      _errors.routeNo = "Please Select Route";
    }

    if (!selectedAssignee) {
      _errors.assignee = "Please Select Assignee";
    }

    const hasVaultAccessRequests = selectedRequests.some(
      (elm) =>
        elm.vaultAccessRequired === true || elm.vaultAccessRequired === "Yes",
    );

    if (
      (hasVaultAccessRequests && !selectedSecondaryAssignee) ||
      (isSecondaryAssigneeRequired && !selectedSecondaryAssignee)
    ) {
      _errors.secondaryAssignee = "Please Select Secondary Assignee";
    }

    if (selectedAssignee && selectedAssignee === selectedSecondaryAssignee) {
      _errors.secondaryAssignee = "Secondary Assignee Can't Be Same";
      _errors.assignee = "Assignee Can't Be Same";
    }

    setErrors(_errors);

    if (Object.keys(_errors).length > 0) {
      return;
    }

    assignTeam({
      routeNo: selectedRoute,
      assigneeId: selectedAssignee,
      secondaryAssigneeId: selectedSecondaryAssignee,
      dispatcherId: selectedSupervisor || "",
    });

    setSelectedAssignee("");
    setSelectedSecondaryAssignee("");
    setSelectedRoute("");
    setSelectedSupervisor(user.EmployeeId);
  };

  const renderFilterBadges = () => (
    <div className="flex mb-3 gap-2 flex-wrap items-end">
      {Object.keys(filters).map((elm) => {
        if ((hideStatus && elm === "status") || elm === "period") {
          return null;
        }
        return (
          <Badge
            variant="secondary"
            className="gap-3 pr-1 cursor-pointer"
            key={elm}
          >
            {filters[elm].description}
            <CircleX onClick={() => handleClearFilter(elm)} />
          </Badge>
        );
      })}
      {Object.keys(filters).length > 2 && (
        <Badge variant="secondary" className="gap-3 pr-1 cursor-pointer">
          Clear All
          <CircleX onClick={clearAllFilters} />
        </Badge>
      )}
    </div>
  );

  return (
    <>
      <div className="flex mb-3 gap-1">
        <Popover>
          <PopoverTrigger asChild>
            <Button variant="secondary" className="w-max" title="Apply Filters">
              <SlidersHorizontal />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-[540px]">
            <h6 className="font-semibold text-lg">Apply Filters</h6>
            <div className="grid grid-cols-2 gap-2 mt-3">
              <Combobox
                placeholder="Select Cash Center"
                data={[
                  { label: "Select Cash Center", value: "" },
                  ...((cashCentersList?.data || []).map((elm) => ({
                    label: elm.name,
                    value: elm.cashCenterId,
                  })) || []),
                ]}
                value={selectedCashCenter}
                setValue={(value) => {
                  setSelectedCashCenter(value);
                  const name = value
                    ? cashCentersList?.data.find(
                        (elm) => elm.cashCenterId === value,
                      )?.name
                    : "";
                  handleAddFilter("cashCenterId", name, value, "Cash Center");
                }}
              />
              <Combobox
                placeholder="Select Customer"
                data={[
                  { label: "Select Customer", value: "" },
                  ...((customersList?.data || []).map((elm) => ({
                    label: elm.name,
                    value: elm.customerId,
                  })) || []),
                ]}
                value={selectedCustomer}
                setValue={(value) => {
                  setSelectedCustomer(value);
                  const name = value
                    ? customersList?.data.find(
                        (elm) => elm.customerId === value,
                      )?.name
                    : "";
                  handleAddFilter("customerId", name, value, "Customer");
                  setSelectedLocation("");
                  value ? getLocations(value) : resetLocations();
                }}
              />
              {!hideAsset && (
                <Combobox
                  placeholder="Select Asset"
                  data={[
                    { label: "Select Asset", value: "" },
                    ...(locationsList?.data?.map((elm) => ({
                      label: elm.locationId,
                      value: elm.servicePointId,
                    })) || []),
                  ]}
                  value={selectedLocation}
                  setValue={(value) => {
                    const name = value
                      ? locationsList?.data.find(
                          (elm) => elm.servicePointId === value,
                        )?.locationId
                      : "";
                    handleAddFilter("assetId", name, value, "Asset");
                    setSelectedLocation(value);
                  }}
                />
              )}
              <Combobox
                placeholder="Select Activity Type"
                data={[
                  { label: "Select Activity Type", value: "" },
                  ...(activityTypesRes?.data?.map((elm) => ({
                    label: elm.description,
                    value: elm.description,
                  })) || []),
                ]}
                value={selectedActivityType}
                setValue={(value) => {
                  handleAddFilter(
                    "activityType",
                    value,
                    value,
                    "Activity Type",
                  );
                  setSelectedActivityType(value);
                }}
              />
              {!hideStatus && (
                <Select
                  onValueChange={(e) => {
                    setSelectedStatus(e);
                    handleAddFilter("status", e, e, "Status");
                  }}
                  value={selectedStatus}
                >
                  <SelectTrigger>
                    <SelectValue placeholder="Select Status" />
                  </SelectTrigger>
                  <SelectContent
                    className="h-[200px]"
                    position="popper"
                    side="bottom"
                  >
                    {STATUS_LIST.map((elm, index) => (
                      <SelectItem key={`${index}-${elm.text}`} value={elm.id}>
                        {elm.text}
                      </SelectItem>
                    ))}
                  </SelectContent>
                </Select>
              )}
              {!hideAssignmentGroup && (
                <Combobox
                  placeholder="Select Assignment Group"
                  data={[
                    { label: "Select Assignment Group", value: "" },
                    ...assignmentGroupList,
                  ]}
                  value={selectedAssignment}
                  setValue={(value) => {
                    handleAddFilter(
                      "assignmentGroup",
                      value,
                      value,
                      "Assignment Group",
                    );
                    setSelectedAssignment(value);
                  }}
                />
              )}
              <Combobox
                setValue={(value) => {
                  handleAddFilter("routeNo", value, value, "Route");
                  setRoute(value);
                }}
                value={route}
                placeholder="Select Route"
                data={[
                  { label: "Select Route", value: "" },
                  ...(routesList?.data || []).map((elm) => ({
                    ...elm,
                    label: `${elm.routeNo}-${elm.description}`,
                    value: elm.routeNo,
                  })),
                ]}
              />
              {!hideAssignee && (
                <Combobox
                  setValue={(value) => {
                    handleAddFilter("assignedTo", value, value, "Assigned To");
                    setAssignee(value);
                  }}
                  value={assignee}
                  placeholder="Select Assignee"
                  data={[
                    { label: "Select Assignee", value: "" },
                    ...(fieldTeam || []).map((elm) => ({
                      ...elm,
                      label: `${elm.employeeId}-${elm.name}`,
                      value: elm.employeeId,
                    })),
                  ]}
                />
              )}
              <Combobox
                placeholder="Response SLA"
                data={[
                  { label: "Select Response SLA", value: "" },
                  ...SLA_LIST,
                ]}
                value={selectedResponseSla}
                setValue={(value) => {
                  setSelectedResponseSla(value);

                  const label =
                    SLA_LIST.find((x) => x.value === value)?.label || "";

                  handleAddFilter("responseSla", label, value, "Response SLA");
                }}
              />
              <Combobox
                placeholder="Resolution SLA"
                data={[
                  { label: "Select Resolution SLA", value: "" },
                  ...SLA_LIST,
                ]}
                value={selectedResolutionSla}
                setValue={(value) => {
                  setSelectedResolutionSla(value);

                  const label =
                    SLA_LIST.find((x) => x.value === value)?.label || "";

                  handleAddFilter(
                    "resolutionSla",
                    label,
                    value,
                    "Resolution SLA",
                  );
                }}
              />
            </div>
          </PopoverContent>
        </Popover>

        <div className="min-w-[15%]">
          <Select
            onValueChange={(e) => {
              setSelectedDate(e);
              handleAddFilter("period", e, e, "Period");
            }}
            value={selectedDate}
          >
            <SelectTrigger>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {PERIODS.map((elm, index) => (
                <SelectItem key={`${index}-${elm.text}`} value={elm.id}>
                  {elm.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="w-full">
          <Input
            value={filter}
            placeholder="Search: Task no, Case No, Status, Activity Type, Category, Sub Category, Bank Reference No, Assignment Group, Route No, Assigned To"
            title="Search: Task no, Case No, Status, Activity Type, Category, Sub Category, Bank Reference No, Assignment Group, Route No, Assigned To"
            onChange={(e) => setFilter(e.target.value)}
          />
        </div>

        {exportExcel ? (
          <Button
            variant="secondary"
            disabled={exportingExcel}
            onClick={onExcelExport}
          >
            {exportingExcel ? <KendoLoader themeColor="light" /> : null}
            <FaFileExcel style={{ marginRight: "8px" }} />
            Export
          </Button>
        ) : null}

        <Button variant="secondary" onClick={onRefresh} title="Refresh List">
          <RefreshCcw style={{ marginRight: "0px", width: "16px" }} />
        </Button>
      </div>

      {bulkUpload ? (
        <div className="flex mb-3 gap-1">
          {!hideSupervisor && (
            <div className="min-w-[15%] w-full flex flex-col gap-1">
              <Combobox
                setValue={setSelectedSupervisor}
                value={selectedSupervisor}
                disabled={selectedRequests.length === 0}
                data={[
                  { label: "Select Supervisor", value: "" },
                  ...(supervisorList?.data || []).map((elm) => ({
                    ...elm,
                    label: `${elm.employeeId}-${elm.name}`,
                    value: elm.employeeId,
                  })),
                ]}
                placeholder="Select Supervisor"
              />
            </div>
          )}

          {!isSLMEngineer && (
            <div className="min-w-[15%] w-full flex flex-col gap-1">
              <Combobox
                setValue={(e) => {
                  setSelectedRoute(e);
                  const _errors = { ...errors };
                  delete _errors.routeNo;
                  setErrors(_errors);
                }}
                value={selectedRoute}
                disabled={selectedRequests.length === 0}
                style={
                  errors.routeNo
                    ? { borderColor: "red", textAlign: "left" }
                    : { textAlign: "left" }
                }
                placeholder="Select Route"
                data={[
                  { label: "Select Route", value: "" },
                  ...(routesList?.data || []).map((elm) => ({
                    ...elm,
                    label: `${elm.routeNo}-${elm.description}`,
                    value: elm.routeNo,
                  })),
                ]}
              />
              {errors.routeNo ? (
                <p className="text-destructive text-xs">{errors.routeNo}</p>
              ) : null}
            </div>
          )}

          <div className="min-w-[15%] w-full flex flex-col gap-1">
            <Combobox
              setValue={(e) => {
                setSelectedAssignee(e);
                const _errors = { ...errors };
                delete _errors.assignee;
                setErrors(_errors);
              }}
              value={selectedAssignee}
              disabled={selectedRequests.length === 0}
              style={
                errors.assignee
                  ? { borderColor: "red", textAlign: "left" }
                  : { textAlign: "left" }
              }
              data={[
                { label: "Select Assignee", value: "" },
                ...(fieldTeam || []).map((elm) => ({
                  ...elm,
                  label: `${elm.employeeId}-${elm.name}`,
                  value: elm.employeeId,
                })),
              ]}
              placeholder="Select Assignee"
            />
            {errors.assignee ? (
              <p className="text-destructive text-xs">{errors.assignee}</p>
            ) : null}
          </div>

          <div className="min-w-[15%] w-full flex flex-col gap-1">
            <Combobox
              setValue={(e) => {
                setSelectedSecondaryAssignee(e);
                const _errors = { ...errors };
                delete _errors.secondaryAssignee;
                delete _errors.assignee;
                setErrors(_errors);
              }}
              value={selectedSecondaryAssignee}
              disabled={selectedRequests.length === 0}
              style={
                errors.secondaryAssignee
                  ? { borderColor: "red", textAlign: "left" }
                  : { textAlign: "left" }
              }
              data={[
                { label: "Select Secondary Assignee", value: "" },
                ...(fieldTeam || []).map((elm) => ({
                  ...elm,
                  label: `${elm.employeeId}-${elm.name}`,
                  value: elm.employeeId,
                })),
              ]}
              placeholder="Select Secondary Assignee"
            />
            {errors.secondaryAssignee ? (
              <p className="text-destructive text-xs">
                {errors.secondaryAssignee}
              </p>
            ) : null}
          </div>

          <Button
            variant="secondary"
            disabled={selectedRequests.length === 0}
            onClick={handleAssignTeam}
          >
            Assign Team
          </Button>
        </div>
      ) : null}

      {renderFilterBadges()}
    </>
  );
}

export default TaskFilterBarV2;
